
import { Component, Vue } from "vue-property-decorator";
@Component({
  components: {},
})
export default class Home extends Vue {
  public value2 = 0;
  // public mounted() {}
  public godownload() {
    window.location.href =
      "https://static.dhsf.hzwlan.com/box/channel_app/1700124448000_Rij8x.apk";
  }
}
